import { messengerApi } from "./messengerApi";

// messenger endpoints behind notification reach: this browser's install/permission state,
// and the one-tap Telegram link. injected into messengerApi so they share its base URL,
// auth headers and reauth handling.

export interface PushDeviceReport {
  installId: string;
  standalone: boolean;
  permission: "granted" | "denied" | "default" | "unsupported";
  pushSupported: boolean;
  endpoint?: string | null;
  platform?: "ios" | "android" | "macos" | "windows" | "linux" | "other";
}

export interface TelegramLinkResponse {
  success: boolean;
  data?: { url: string; expiresInSec: number };
  error?: string;
}

export const messengerReachApi = messengerApi.injectEndpoints({
  endpoints: (builder) => ({
    reportPushDevice: builder.mutation<
      { success: boolean; data?: { resubscribe: boolean } },
      PushDeviceReport
    >({
      query: (body) => ({
        url: "/api/user/push/device",
        method: "POST",
        body,
      }),
    }),
    createTelegramLink: builder.mutation<TelegramLinkResponse, void>({
      query: () => ({
        url: "/api/user/telegram/link",
        method: "POST",
      }),
    }),
  }),
});

export const { useReportPushDeviceMutation, useCreateTelegramLinkMutation } = messengerReachApi;
